import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { InformationIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { EnrollmentInput } from '../../../../lib/types/models/enrollment/enrollment-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import InformationToolTip from '../../../elements/information-tooltip'
import ControlledRadioInput from '../../../elements/inputs/controlled-radio-input'

const ChildAloneEnrollmentForm = () => {
  const form = useFormContext<EnrollmentInput>()

  return (
    <InnerBox className="rounded-2xl">
      <div className="flex flex-col gap-2">
        {form.watch('parentAuthorizedToGoOutAlone') === false && (
          <Typography variant="label-semibold" color={tailwindColors.red.DEFAULT}>
            Les parents ont rejeté l'autorisation
          </Typography>
        )}
        <div className="flex gap-2 items-center">
          <Typography variant="label-semibold">
            Autorisez-vous votre enfant à sortir seul le soir jusqu'à 22h?
          </Typography>
          <InformationToolTip
            align="center"
            icon={
              <InformationIcon
                width="24px"
                height="24px"
                color={tailwindColors.secondary.DEFAULT}
              />
            }
          >
            <Typography
              variant="label-medium"
              color={tailwindColors.white.DEFAULT}
              className="w-56"
            >
              Réservée aux jeunes de plus de 15 ans. Il s'agit de sorties seul, sans
              l'accompagnement d'un adulte, en dehors de la famille et de toute surveillance de LEC
            </Typography>
          </InformationToolTip>
        </div>
        <div className="flex gap-10">
          <FormField
            control={form.control}
            name="canGoOutAlone"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Oui'}
                    checked={field.value === true}
                    onCheck={() => field.onChange(true)}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="canGoOutAlone"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <ControlledRadioInput
                    {...field}
                    label={'Non'}
                    checked={field.value === false}
                    onCheck={() => field.onChange(false)}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
    </InnerBox>
  )
}

export default ChildAloneEnrollmentForm
